<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">账号开通</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="商户名称">
                <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="商户手机号">
                <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-button size="small" style="margin-bottom:15px" type="primary" @click="addClick">新增商户</el-button>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="storeName" label="商户名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" label="商户手机号" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="tradeName" label="行业" ></el-table-column>
            <el-table-column  prop="createdAt" label="注册时间">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="status" label="账号状态" >
                <template slot-scope="scope">
                    <div>{{scope.row.status == 1?'正常':'禁用'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="gamebar开关">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.barstatus"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        @change="updateUserBarStatusChange(scope.row)"
                        inactive-color="#409EFF">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                    <el-button size="mini" type="text" v-if="scope.row.status == 1" v-preventReClick @click="updateUserStatus(0, scope.row)">禁用</el-button>
                    <el-button size="mini" type="text" v-if="scope.row.status == 0" v-preventReClick @click="updateUserStatus(1, scope.row)">启用</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="180px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="注册手机号：" prop="phone">
                <el-input size="small" v-model="editForm.phone " style="width:230px" auto-complete="off" placeholder="请输入注册手机号"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：" prop="passwordVlaue">
                    <el-button size="small" v-if="editForm.id != '' && editPasswordFlag == false" type="primary" @click="editPasswordFlag = true" class="title">修改密码</el-button>
                    <el-input size="small" v-if="editForm.id == '' || editPasswordFlag == true" v-model="editForm.passwordVlaue" style="width:230px" auto-complete="off" placeholder="如不输入，则默认123456"></el-input>
                    <el-button size="small" v-if="editPasswordFlag == true" type="primary" @click="editPasswordFlag = false" class="title">取消</el-button>

                </el-form-item>
                <el-form-item label="收银系统中的商户名称：" prop="storeName">
                <el-input size="small" v-model="editForm.storeName" style="width:230px" auto-complete="off" placeholder="请输入收银系统中的商户名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" prop="name">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="行业：" prop="tradeId">
                    <el-select v-model="editForm.tradeId" placeholder="请选择">
                        <el-option
                        v-for="item in loadTradeListData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限设置：" >
                    <div>默认拥有全部收银系统权限</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="商户详情" :visible.sync="detailsFlag" width="30%" @click="closeDialog">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions :column="1">
                        <template slot="extra">
                            <el-button type="primary" size="small" @click="editClick">编辑</el-button>
                        </template>
                        <el-descriptions-item label="商家名称">{{ detailsForm.storeName }}</el-descriptions-item>
                        <el-descriptions-item label="联系人">{{ detailsForm.name }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{ detailsForm.phone }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ detailsForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="行业">{{ detailsForm.tradeName }}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="绑定机器" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machineData" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="主屏id" label="主屏id" ></el-table-column>
                    <el-table-column  prop="机器状态" label="机器状态" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadChargeUserList , loadTradeList , authentica  , saveChargeUser , updateUserStatus , updateUserBarStatus } from '../../../api/userMG'
export default {
    data(){
        return{
            editPasswordFlag:false,
            detailsForm:{},
            loadTradeListData:[],
            editFlag:false,
            rules:{},
            loading:false,
            status:false,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{
                storeName:'',
                name:'',
                phone:'',
                tradeId:'',
                passwordVlaue:'',
                id:''
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                storeName : [
                { required: true, message: '请输入收银系统中的商户名称', trigger: 'blur' }
                ],
                name : [
                { required: true, message: '请输入联系人', trigger: 'blur' }
                ],
                phone : [
                { required: true, message: '请输入注册手机号', trigger: 'blur' },
                {
                        pattern: /^1\d{10}$/,
                        required: true,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }
                ],
                tradeId : [
                { required: true, message: '请选择行业', trigger: 'blur' }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.loadTradeList()
    },
    methods:{
        updateUserBarStatusChange(e){
            updateUserBarStatus({
                id:e.id,
                status:e.barstatus.toString()
            }).then(res=>{

            })
        },
        loadTradeList(){
            loadTradeList().then(res=>{
                this.loadTradeListData = res.tradeList
            })
        },
        editClick(){
            this.editForm = JSON.parse(JSON.stringify(this.detailsForm))
            this.editPasswordFlag = false
            this.editFormVisible = true
        },
        addClick(){
            this.editForm = {
                storeName:'',
                name:'',
                phone:'',
                tradeId:'',
                passwordVlaue:'',
                id:''
            }
            this.editFormVisible = true
        },  
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let password = ''
                    if(this.editPasswordFlag == true ){
                        password = this.editForm.passwordVlaue == ''?'123456':this.editForm.passwordVlaue
                    }else if(this.editPasswordFlag == false && this.editForm.id == '') {
                        password = this.editForm.passwordVlaue == ''?'123456':this.editForm.passwordVlaue
                    }else {
                        password = ''
                    }
                    saveChargeUser({
                        name:this.editForm.name,
                        storeName:this.editForm.storeName,
                        phone:this.editForm.phone,
                        tradeId:this.editForm.tradeId,
                        password:password,
                        id:this.editForm.id
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success(this.editForm.id == ''?'创建成功':"修改成功")
                            if(this.editForm.id != ''){
                                this.editForm.passwordVlaue = ''
                                this.detailsForm = this.editForm
                            }
                            this.editPasswordFlag = false
                            this.editForm = {
                                storeName:'',
                                name:'',
                                phone:'',
                                tradeId:'',
                                passwordVlaue:'',
                                id:''
                            }
                            this.editFormVisible = false
                            this.getdata()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        updateUserStatus(status , row){
            this.$confirm(`确认是否${status == 1?'启用':'禁用'}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateUserStatus({id:row.id ,status:status}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        authenticaChange(e){
            authentica({
                status:e,
                id:this.editForm.id
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.messages)
                }else {
                    this.$message.success('修改成功')
                    this.getdata()
                }
            })
        },  
        handleEdit(index , row){
            this.activeName = "information"
            this.detailsFlag = true
            this.status = row.attestation
            row.passwordVlaue = ''
            this.detailsForm = row
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadChargeUserList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                storeName:this.formInline.name,
                phone:this.formInline.phone,
            }).then(res=>{
                this.listData = res.userList.list
                this.pageparm.total = res.userList.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/cashierManagement/userManage/account.vue